import React from "react";
import Link from "next/link";
import styles from "./SeoLink.module.css";

interface SeoLinkProps {
  title: string;
  slug: string;
  job_title?: string;
}

const SeoLink: React.FC<SeoLinkProps> = ({ title, slug, job_title }) => {
  const displayTitle = job_title || title;

  return (
    <Link
      href={`/job/${slug}`}
      className={styles.link}
    >
      {displayTitle} Resume
    </Link>
  );
};

export default SeoLink;
